var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaintLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 252,
    height: 59,
    viewBox: "0 0 252 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.936 25.338c-1.322 8.685-22 11.162-14.171 29.085 13.17 8.077 24.548-6.365 35.3-11.845 6.882-3.507 25.285-19.472 33.894-17.24 7.984 2.07 8.894 15.987 20.172 17.944 21.649 3.755 43.177-8.982 59.342-21.814 1.756-1.394 13.58-14.51 15.246-8.678 2.762 9.665 14.263 9.955 22.752 8.913C211.265 19.149 229.822 2 250.048 2",
    stroke: "#FD1050",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
export default SvgPaintLine;